import { defaultDashboardState } from './module-dashboard-state';

export default {
	resetState(state) {
		Object.assign(state, defaultDashboardState);
	}
};
